export const formatCurrency = (value: number, currency?: string) => {
    if (!currency) return value.toFixed(2);
    return value.toLocaleString('en-US', { style: 'currency', currency })
}